import type { SVGProps } from "react";
import { cn } from "../../utils/global.utils";

export default function CheckIcon({
  className,
  size = 24,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("", className)}
      {...props}
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
